import styled from 'styled-components';
import { Col, type ColProps } from 'antd';

interface FeedbackContainerProps extends ColProps {
  align?: string;
}

const FeedbackContainer = styled(Col)<FeedbackContainerProps>`
  padding-top: 24px;

  @media only screen and (min-width: 1025px) {
    align-items: center;

    .ant-carousel {
      max-width: 1020px;
    }
  }
`;

export default FeedbackContainer;
